<template>
  <div class="Footer">
    <div class="baseNav">
      <div class="NavList">
        <router-link to="/">
          <img
            class="NavImg"
            :src="
              this.$route.path == '/'
                ? require('../assets/imgs/phonePitch.png')
                : require('../assets/imgs/phoneDefault.png')
            "
            alt=""
          />
          <div :class="['Navname', this.$route.path == '/' ? 'active' : '']">
            云手机
          </div>
        </router-link>
      </div>
      <!-- <div class="NavList">
        <router-link to="/discover">
          <img
            class="NavImg"
            :src="
              this.$route.path == '/discover'
                ? require('../assets/img/discoverAmend/navIcon_active.png')
                : require('../assets/img/discoverAmend/navIcon.png')
            "
            alt=""
          />
          <div
            :class="[
              'Navname',
              this.$route.path == '/discover' ? 'active' : '',
            ]"
          >
            发现
          </div>
        </router-link>
      </div> -->
      <div class="NavList">
        <router-link to="/mine">
          <img
            class="NavImg"
            :src="
              this.$route.path == '/mine'
                ? require('../assets/imgs/myPitch.png')
                : require('../assets/imgs/myDefault.png')
            "
            alt=""
          />
          <div
            :class="['Navname', this.$route.path == '/mine' ? 'active' : '']"
          >
            我的
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AochenFooter",
  data() {
    return {
      active: 0,
    };
  },

  mounted() {
    if (this.$route.path == "/discover") {
      this.active = 1;
    }
    if (this.$route.path == "/mine") {
      this.active = 2;
    }
  },

  methods: {
    onChange() {},
  },
};
</script>

<style lang="less" scoped>
.navnameBox {
  width: 40px;
  height: 40px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  a {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .NavImg {
    width: 20px;
    margin-bottom: 4px;
  }
  .Navname {
    font-size: 11px;
    color: #aaabad;
    line-height: 13px;
    text-align: center;
  }
  .active {
    color: #0066ff;
  }
}
.Footer {
  // position: fixed;
  position: absolute;
  max-width: 375px;
  bottom: 0;
  // left: 0;
  width: 100%;
  height: 56px;
  background-color: #fff;
  border-top: 1px solid rgba(32,55,126,0.1);
  .baseNav {
    width: 100%;
    height: 100%;
    display: flex;
    .NavList {
      width: 50%;
      text-align: center;
      height: 100%;
      a {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }
      .NavImg {
        width: 29px;
        margin-bottom: 2px;
      }
      .Navname {
        font-weight: 500;
        font-size: 10px;
        color: #505465;
      }
      .active {
        color: #886df3;

      }
    }
  }
}
</style>